import * as React from 'react';
import { Logo } from '@moovly/ui';
import './NotAllowed.scss';
import { t } from '@moovly/i18n';
const NotAllowed = () => {
  // @todo update this
  return (
    <main className="NotAllowed">
      <Logo className="Logo" width={180} />
      <section className="Panel content-section">
        <h4>{t('unAuthorized.description')}</h4>
      </section>
    </main>
  );
};

export default NotAllowed;
